"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCard = exports.buildPieceModel = exports.buildDefinition = void 0;
const buildDefinition = (definition = {}) => (Object.assign({ id: 1, name: "Creature", traits: ["earth", "arcane"], cost: 1, attackRange: 1, stages: [] }, definition));
exports.buildDefinition = buildDefinition;
const buildPieceModel = (piece = {}) => (Object.assign({ id: "123", ownerId: "abc", definitionId: 1, maxHealth: 100, stage: 0, traits: [] }, piece));
exports.buildPieceModel = buildPieceModel;
const buildCard = (card = {}) => (Object.assign({ id: "123", name: "Card", definitionId: 1, traits: ["metal", "arcane"], cost: 1 }, card));
exports.buildCard = buildCard;
